import { usageTypeIcons } from "../lib/connector";
import { pluralize } from "../lib/inflection";
import { ConnectorLogoContainer } from "./ConnectorLogoContainer";
import { FacePile } from "./FacePile";
import { Icon, type IconName } from "./Icon";
import { Tooltip } from "./Tooltip";

export function ConnectorUsageIcons({
  usages,
}: {
  usages: readonly { type: string; refId: string }[];
}) {
  const workflowIds = new Set<string>();
  const counts = new Map<string, number>();
  for (const usage of usages) {
    if (usage.type === "workflow_slug") workflowIds.add(usage.refId);
    else counts.set(usage.type, (counts.get(usage.type) ?? 0) + 1);
  }

  const all: { id: string; icon: IconName; count: number; noun: string }[] = [
    {
      id: "workflows",
      icon: usageTypeIcons.workflow,
      count: workflowIds.size,
      noun: "workflow",
    },
    {
      id: "personal_chat",
      icon: usageTypeIcons.personal_chat,
      count: counts.get("personal_chat") ?? 0,
      noun: "chat",
    },
    {
      id: "space_git_remote",
      icon: usageTypeIcons.space_git_remote,
      count: counts.get("space_git_remote") ?? 0,
      noun: "git sync",
    },
    {
      id: "audit_log_destination",
      icon: usageTypeIcons.audit_log_destination,
      count: counts.get("audit_log_destination") ?? 0,
      noun: "audit log destination",
    },
  ];
  const entries = all.filter((entry) => entry.count > 0);
  if (entries.length === 0) return null;

  return (
    <FacePile
      itemSize={24}
      outlineWidth={2}
      cutout
      items={entries.map((entry) => {
        const label = `${entry.count} ${pluralize(entry.noun, entry.count)}`;
        return {
          id: entry.id,
          label,
          bare: true,
          node: (
            <Tooltip content={label}>
              <ConnectorLogoContainer
                size={24}
                outline={false}
                outlineWidth={2}
              >
                <Icon
                  name={entry.icon}
                  size={12}
                  color="var(--text-secondary)"
                />
              </ConnectorLogoContainer>
            </Tooltip>
          ),
        };
      })}
    />
  );
}
